<div class="input-container">
  <div class="header">
    @if (label) {
      <div class="label">{{ label }}</div>
    }

    @if (link && text) {
      <div>
        <app-link [link]="link" [text]="text"/>
      </div>
    } @else {
      <app-form-switch-button
        [text]="switchBtnText"
        (switchForm)="onClickBtn()"
      />
    }
  </div>

  <div
    class="input-wrapper"
    [class]="{'error': validationError || displayValidationError, 'check': checkedState, 'warn': warningState}"
  >
    <input
      type="text"
      class="input"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [(ngModel)]="value"
      (input)="onInput($event)"
      (keydown)="onKeyPressed($event)"
      (focusin)="focusin.emit($event)"
      (blur)="blured.emit(); onTouched()"
    >

    <app-tooltip [customContent]="true">
      <i
        container="body"
        class="input-icon icon"
        placement="top"
        [ngbTooltip]="this.getValidationErrorMsg()"
        [tooltipClass]="'tooltip-info'"
        [class]="{'ic-info-circle-16': validationError || warningState || displayValidationError, 'ic-checkmark-circle-16': checkedState}">
      </i>
    </app-tooltip>
  </div>

  @if (helperText) {
    <div class="helper" [class]="{'error': validationError}">{{ helperText }}</div>
  }

  @if (shouldShowErrors && displayValidationError) {
    <app-validation-error [customErrors]="customErrors"></app-validation-error>
  }
</div>
